import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import './lottery_styles/lotteryrules.css';

export default function LotteryRules() {
  return (
    <>
     <Container className='mt-5 mb-5'>
      <Row>
        <Col>
          <div className="rules">
            <div className="rule_head d-flex flex-column justify-content-center align-items-center">
              <h2>Event Rules</h2>
              <span>SuperEx Fun Mystery Box Opening Event With 100% Winning Rate</span>
            </div>
            <div className="rule_activity">
              <p className='fw-bold'>Activities:</p>
              <span>During the event period share your invitation code/link with friends who have not
                registered on SuperEx, and after completing the simple tasks, you and your referral will
                jointly receive mystery box rewards. Your invited friends need to complete the following tasks:
              </span>
            </div>
            <Row className='mt-5 rule_lower'>
              <Col lg={4}>
                <div className="rule_lower1">
                  <span>1</span>
                </div>
              </Col>
              <Col lg={4}>
                <div className="rule_lower1">
                  <span>2</span>
                </div>
              </Col>
              <Col lg={4}>
                <div className="rule_lower1">
                  <span>3</span>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
     </Container>
    </>
  )
}
